import React, { useEffect } from 'react';
import { CancellationFlowStep } from 'store/dashboard/types';
import { useDispatch, useSelector } from 'react-redux';
import { setCancellationFlowStep } from 'store/dashboard/slice';
import getCancellationConfirmationPage from 'store/dashboard/selector/getCancellationConfirmationPage';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import cn from 'classnames';
import fetchCancellationConfirmationPageOperation from 'store/dashboard/operation/fetchCancellationConfirmationPageOperation';
import SubscriptionCompact from '../SubscriptionCompact/SubscriptionCompact';
import AdditionalOptions from '../AdditionalOptions/AdditionalOptions';
import styles from './CancellationConfirmation.module.scss';

const CancellationConfirmation = () => {
  const confirmationPageData = useSelector(getCancellationConfirmationPage);
  const dispatch = useDispatch();

  const setStep = (step: CancellationFlowStep) => {
    dispatch(setCancellationFlowStep(step));
  };

  useEffect(() => {
    dispatch(fetchCancellationConfirmationPageOperation());
  }, []);

  if (!confirmationPageData) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>{confirmationPageData.txtTitle}</h1>
      <div className={styles.susbcriptionDetails}>
        <SubscriptionCompact
          memberSinceDate={confirmationPageData.memberSinceDate}
          moneySaved={confirmationPageData.moneySaved}
          totalOrders={confirmationPageData.totalOrders}
          txtMemberSince={confirmationPageData.txtMemberSince}
          txtMoneySaved={confirmationPageData.txtMoneySaved}
          txtTotalOrders={confirmationPageData.txtTotalOrders}
        />
      </div>
      <h2 className={styles.subHeading}>{confirmationPageData.txtLoseBenefits}</h2>
      <div className={styles.benefits}>
        {confirmationPageData.benefits.map((benefit: any) => (
          <div className={styles.benefit} key={benefit.imageUrl}>
            <img src={benefit.imageUrl} alt="Benefit" className={styles.benefit__image} />
            <div className={styles.benefit__description}>{benefit.description}</div>
          </div>
        ))}
      </div>
      <h2 className={styles.subHeading}>{confirmationPageData.txtReviewTitle}</h2>
      <div className={styles.reviews}>
        {confirmationPageData.reviews.map((review: any) => (
          <div className={styles.review} key={review.customerPhotoUrl}>
            <div className={styles.review__content} dangerouslySetInnerHTML={{ __html: review.content }} />
            <div className={styles.review__customer}>
              <img src={review.customerPhotoUrl} alt="Customer" className={styles.review__customer__image} />
              <span>{review.customerInfo}</span>
            </div>
          </div>
        ))}
      </div>

      <hr className={styles.devider} />
      <h2 className={styles.subHeading}>{confirmationPageData.txtPolicyTitle}</h2>
      <div dangerouslySetInnerHTML={{ __html: confirmationPageData.txtPolicyDescription }} className={styles.policy} />
      <div className={styles.additionalOptions}>
        <AdditionalOptions
          contactCsTxt={confirmationPageData.txtContactCs}
          contactCsUrl={confirmationPageData.txtContactCsUrl}
          helpText={confirmationPageData.txtOptionsNeedHelp}
          title={confirmationPageData.txtOptionsTitle}
        />
      </div>
      <div className={styles.actions}>
        <OpButton onClick={() => setStep(CancellationFlowStep.reasons)} block variant="secondary" color="teal">
          <OpText variant="body-large-medium" className={cn(styles.action, styles['action--secondary'])}>
            {confirmationPageData.txtYesCancelButton}
          </OpText>
        </OpButton>
        <OpButton onClick={() => setStep(CancellationFlowStep.initial)} block variant="primary" color="teal">
          <OpText variant="body-large-medium" className={cn(styles.action, styles['action--primary'])}>
            {confirmationPageData.txtNoKeepButton}
          </OpText>
        </OpButton>
      </div>
    </div>
  );
};

export default CancellationConfirmation;
